'use strict';

var React = require('react');

var SvgTransportMajor = function SvgTransportMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.75 7.75a2.25 2.25 0 0 1 0 4.5h-1.74l-1.583 3.322a.75.75 0 0 1-.677.428h-2.25a.75.75 0 0 1-.742-.856l.413-2.894h-.88l-.684.941a.75.75 0 0 1-.607.309h-2.25a.75.75 0 0 1-.705-1.006l.907-2.494-.907-2.494a.75.75 0 0 1 .705-1.006h2.25a.75.75 0 0 1 .607.309l.684.941h.88l-.413-2.894a.75.75 0 0 1 .742-.856h2.25a.75.75 0 0 1 .677.428l1.582 3.322h1.741Zm.75 2.25a.75.75 0 0 0-.75-.75h-2.214a.75.75 0 0 1-.677-.428l-1.583-3.322h-.911l.413 2.894a.75.75 0 0 1-.742.856h-2.127a.75.75 0 0 1-.606-.309l-.685-.941h-.797l.634 1.744a.75.75 0 0 1 0 .512l-.634 1.744h.797l.685-.941a.75.75 0 0 1 .606-.309h2.127a.75.75 0 0 1 .742.856l-.413 2.894h.911l1.583-3.322a.75.75 0 0 1 .677-.428h2.214a.75.75 0 0 0 .75-.75Z"
  }));
};
SvgTransportMajor.displayName = "TransportMajor";

exports.SvgTransportMajor = SvgTransportMajor;
